let hs = {};
hs.api = {};

/**
 * getHSQueryResult
 *
 * @param {object}
 * @return {Promise}
 *
 * NOTE: either queryID or Alias should be used
 * @example
 *  hs.api.getHSQueryResult(
 * 		{
 * 			formID:"78864d87-2e9c-4b94-afaf-0f551f075477"
 * 			, queryID:"315864d87-2e9c-4b94-afaf-0f551f075477"
 * 			, params: JSON.stringify({
 * 						inspectionID: "70E2A527-57EF-4A9E-88A4-4F3C9DDC325C"
 * 					})
 * 		});
 *
 */
hs.api.getHSQueryResult = async function (jurisdiction, formID, alias, params={}) {
	return new Promise((resolve, reject) => {
		var schema = {
			required: true,
			type: 'object',
			properties: {
				jurisdiction: {
					required: true,
					type: 'string',
					comment: 'the name of the jurisdiction'
				},
				formID: {
					required: true,
					type: 'string',
					comment: 'primary key value of the form'
				},
				alias: {
					required: true,
					type: 'string',
					comment: 'an alias that defines the query'
				},
				params: {
					required: false,
					type: 'object',
					$comment: 'all the data you want to pass'
				},
			},
		};

		app.ajax.request(
		{
			url: `/getHSQuery?jurisdiction=${jurisdiction}&formID=${formID}&alias=${alias}&params=${params}`,
			method: "GET",
			contentType: "application/json",
			responseType: "text/html",
			success: function(res) {
				resolve(JSON.safeParse(res).responseText);
			},
			error: function(err) {
				console.log('ERROR:', err);
				reject;
			}
		});

	});
};

// Check if modules are supported
if (typeof module !== 'undefined' && module.exports) {
	// Standard node module exports
	module.exports = {
		api: hs.api,
	};
}
